import React from 'react'
import Projects from './Projects'

function App () {
  return (
    <>
      <h1>Andrew Steffey&apos;s freeCodeCamp Projects</h1>
      <Projects/>
    </>
  )
}

export default App
